import { createLucideIcon } from "lucide-react";

export const Location = createLucideIcon(
    "Location",
    [
        [
            "path",
            {
                d: "M10.3346 7.33333C10.3346 8.622 9.28997 9.66667 8.0013 9.66667C6.71264 9.66667 5.66797 8.622 5.66797 7.33333C5.66797 6.04467 6.71264 5 8.0013 5C9.28997 5 10.3346 6.04467 10.3346 7.33333Z",
                key: "1xillc",
            },
        ],
        [
            "path",
            {
                d: "M8 1.33325C11.247 1.33325 14 4.0219 14 7.28376C14 10.5976 11.2022 12.9231 8.618 14.5044C8.42967 14.6107 8.2167 14.6666 8 14.6666C7.7833 14.6666 7.57033 14.6107 7.382 14.5044C4.8026 12.9076 2 10.609 2 7.28376C2 4.0219 4.75296 1.33325 8 1.33325Z",
                key: "c6y7n6",
            },
        ],
    ],
);
